import {Map} from 'immutable';
import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import CallActions from 'actions/CallActions';
import SearchInputActions from 'actions/search/SearchInputActions';
import ManagerDashboardState from 'records/ManagerDashboard';
import ManagerDashboardSource from 'sources/ManagerDashboardSource';
import {browserHistory} from 'react-router';
import {LocalStorageKey} from '@store/@types/util/LocalStorageKey';
import {scrollToTop} from 'utils/scrollToTop';

@immutableStore
class ManagerDashboardStore {
  constructor() {
    this.bindActions(ManagerDashboardActions);
    this.onGetWidget = this.onGetWidget.bind(this);
    this.getWidgetSuccess = this.getWidgetSuccess.bind(this);
    this.getWidgetError = this.getWidgetError.bind(this);
    this.showCalls = this.showCalls.bind(this);
    this.getScoredCallIdsSuccess = this.getScoredCallIdsSuccess.bind(this);
    this.getScoredCallIdsError = this.getScoredCallIdsError.bind(this);
    this.onSaveDashboardSearch = this.onSaveDashboardSearch.bind(this);

    const widgetState = JSON.parse(localStorage.getItem(LocalStorageKey.WIDGET_STATE));
    this.state = new ManagerDashboardState({widgetState: Map(widgetState)});
  }

  /**
   * Config settings are saved and posted back to the server when the user comes back to the dashboard
   * we want to keep the settings for "my" dashboard separate from the settings of other people's dashboards that I view.
   *
   * @param managerId
   * @returns {string}
   */
  getConfigKey(managerId) {
    // if the managerId is set, you are viewing someone else's dashboard
    const isOtherDashboard = Boolean(managerId);
    return isOtherDashboard ? 'others' : 'mine';
  }

  onGetWidget([widgetOptions, managerId]) {
    let updatedState = this.state;
    const configKey = this.getConfigKey(managerId);
    updatedState = updatedState.setIn(
      ['widgetConfig', configKey, widgetOptions.widgetId],
      widgetOptions
    );
    this.setState(updatedState);
    ManagerDashboardSource.getWidget([widgetOptions, managerId]);
  }

  getWidgetSuccess(response) {
    let updatedState = this.state;
    let widgets = updatedState.get('widgets');
    widgets = widgets.set(response.widgetId, response);
    updatedState = updatedState.set('widgets', widgets);

    if (this.state.managerId === null) {
      updatedState = updatedState.set('widgetsCache', widgets);
    }

    this.setState(updatedState);
  }

  getWidgetError(response) {
    console.warn(response);
  }

  showCalls(callIds) {
    CallActions.updateFileId(callIds);

    browserHistory.push({
      pathname: '/calls/my',
    });

    scrollToTop();
  }

  getScoredCallIdsSuccess(response) {
    setTimeout(() => {
      this.showCalls(response.callIds);
    }, 0);
  }

  getScoredCallIdsError(response) {
    console.warn(response);
  }

  onSaveDashboardSearch(dashboardSearch) {
    let updatedState = this.state;
    updatedState = updatedState.set('search', dashboardSearch);
    this.setState(updatedState);
  }

  onSetShouldResetSearch(shouldResetSearch) {
    let updatedState = this.state;
    updatedState = updatedState.set('shouldResetSearch', shouldResetSearch);
    this.setState(updatedState);
  }

  onSetWidgetState([widgetId, value]) {
    let updatedState = this.state;
    const widgetState = updatedState.get('widgetState');
    const newWidgetState = widgetState.set(widgetId, value);
    updatedState = updatedState.set('widgetState', newWidgetState);
    this.setState(updatedState);
    localStorage.setItem(LocalStorageKey.WIDGET_STATE, JSON.stringify(newWidgetState.toJSON()));
  }

  onGetWidgetState(widgetId) {
    const widgetState = this.state.get('widgetState');
    return widgetState.get(widgetId);
  }

  deferClearSearch() {
    SearchInputActions.clearSearchInputValue.defer();
    CallActions.clearSearch.defer();
  }

  hasRenderedDashv2Gif() {
    this.setState({
      hasRenderedDashv2Gif: true,
    });
  }

  reset() {
    this.setState({
      widgets: Map(),
    });
  }
}

export default alt.createStore(ManagerDashboardStore, 'ManagerDashboardStore');
